export const GlobalVariable = Object.freeze({
  // prod
  BASE_API_URL:   'https://svc.pap.bestcash.me/clk',
  BASE_MEDIA_URL: 'https://svc.pap.bestcash.me/',
  PUBLIC_API_URL: 'https://svc.pap.bestcash.me/public',
  BASE_COLLECT_API_URL: 'https://svc.pap.bestcash.me/collect/clk',
  SMS_PROVIDERS: ['INFOBIP', 'NEXMO', 'PANACEA', 'MOOV', 'WIREPICK', 'MTN'],
  COLLECTION_API: ['KKIAPAY', 'PROVIDER_SPECIFIC'],
  PASSWORD_MAX_AGE: 30,
  CUSTOMER_ID_TYPES: ['CI', 'PA', 'PC', 'CP', 'CIP', 'CR', 'TS', 'CC', 'NONE'],
  WHATSAPP_MESSAGE_PROVIDER: ['WASSENGER'],
  AIRTIME_PROVIDER: ['SOCHITEL'],
  DEBUG_REQUESTS_MODE: false,
  MINIMUM_CREDIT_OPERATION_AMOUNT: 10,
  MINIMUM_DEBIT_OPERATION_AMOUNT: 10,
  MINIMUM_TRANSFER_OPERATION_AMOUNT: 10,
  MINIMUM_CREDIT_DEPOSITACCOUNTOPERATION_AMOUNT: 10,
  MINIMUM_DEBIT_DEPOSITACCOUNTOPERATION_AMOUNT: 10,
  MINIMUM_PAYEMENT_DEPOSITACCOUNTOPERATION_AMOUNT: 10,
  MINIMUM_CASHOUT_OPERATION_AMOUNT: 10,
  MINIMUM_COLLECT_PRODUCT_AMOUNT: 10,
  TEST_MODE: true
});




// WEBPACK FOOTER //
// ./src/app/global.ts